import React from "react"

import Board_Manager from "../../../../managers/manager"
import Board_GroupBy from "../../../../managers/group-by/group-by"
import FieldFormElementView from "../../../../../../../fields3/render/form-elemnent-view"
import FieldsFactory from "../../../../../../../fields3/fields-factory"
import {FieldType} from "../../../../../../../fields3/field-type"
import FieldSelectField from "../../../../../../../fields3/generic/select/select-field/select-field"
import {
    AggregateFunctionName,
    AggregateFunctionType
} from "../../../../../../../data-structures/aggregators/types"
import {LifecycleAction} from "../../../../../../../gd/const/lifecycle"
import {useForceUpdate} from "../../../../../../../gd/utils/dom-and-react/react-utils"
import Board_Settings from "../../../../managers/settings/settings"

type Props = {
    className?  : string

    manager     : Board_Manager
}

// const debug = "Board_ShowTotal_OptionRows"
const debug = false

export default function Board_ShowTotal_OptionRows(props: Props) {
    const forceUpdate = useForceUpdate()

    const groupBy = props.manager.groupBy as Board_GroupBy

    if (groupBy.isSingleRow) {
        return null
    }

    const settings = props.manager.settings as Board_Settings

    const onChangeField = (fieldId?: string) => {
        debug && console.log(debug, 'onChangeField', fieldId)

        if (fieldId) {
            const aggregateField = props.manager.fields.get(fieldId)

            const availableAggregateFunctions: AggregateFunctionType[] = aggregateField.getAggregateOptions()
            let aggregateFunction
            // leave current aggregate function if it is available for new field
            if (availableAggregateFunctions.includes(settings.rowsAggregate?.function!)) {
                aggregateFunction = settings.rowsAggregate?.function
            } else {
                aggregateFunction = aggregateField.getDefaultAggregateFunction() || availableAggregateFunctions[0]
            }

            settings.rowsAggregate = {
                fieldId     : fieldId,
                function    : aggregateFunction
            }
        } else {
            settings.rowsAggregate = undefined
        }

        // recalculate children and rerender
        props.manager.update([
            LifecycleAction.PROCESS_DATA,
            LifecycleAction.RENDER,
        ])

        forceUpdate()
    }

    const onChangeFunction = (value?: AggregateFunctionType) => {
        if (!settings.rowsAggregate) {
            return
        }

        debug && console.log(debug, 'onChangeFunction', value)

        const rowsAggregate = _.cloneDeep(settings.rowsAggregate)
        rowsAggregate.function = value
        settings.rowsAggregate = rowsAggregate


        // recalculate children and rerender
        props.manager.update([
            LifecycleAction.PROCESS_DATA,
            LifecycleAction.RENDER,
        ])

        forceUpdate()
    }

    const fieldSelector = FieldsFactory.get({
        type                : FieldType.SELECT_FIELD,
        fieldId             : 'fieldId',
        fields              : props.manager.fields,
        fieldsStructure     : props.manager.fields.structureAggregateFields(props.manager.viewType, props.manager.getCustomFields()),
        fieldParams         : {
            keepPopoverOpenOnSelect: true
        },
        noValueOption       : true,
        noValueOptionLabel  : 'Not selected',
    }) as FieldSelectField

    const aggregateField        = settings.rowsAggregate?.fieldId ? props.manager.fields.get(settings.rowsAggregate.fieldId) : undefined
    const aggregateFunctions    = aggregateField?.getAggregateOptions()
    const functionsOptions: Option[] = []
    {_.map(aggregateFunctions, (value: AggregateFunctionType)=>{
        functionsOptions.push({
            value       : value,
            label       : AggregateFunctionName[value as AggregateFunctionType],
            isSelected  : settings.rowsAggregate?.function === value,
        })
    })}

    const fieldFunctionSelector = FieldsFactory.get({
        type                : FieldType.DROPDOWN,
        fieldId             : 'function',
        options             : functionsOptions,
        showMenuMore        : false,
        fieldParams         : {
            keepPopoverOpenOnSelect: true
        },
        noValueOption       : false,
    }) as FieldSelectField

    debug && console.log(debug, 'render', props, settings.rowsAggregate)

    const isAggregateSelected = !!settings.rowsAggregate

    const classes = Classes("border-box min-h-36 p-l-20 p-r-15 p-b-5")

    const selectorsContainerClasses = Classes("flex-row-left-center h-45 ", props.className, {
        'm-t-5': !groupBy.isSingleColumn
    })

    const showTitle = groupBy.isRowsAndColumns

    return (
        <div className={classes}>
            <div className="flex-row-left-center w-100p">
                {showTitle &&
                    <div className="flex-row-left-center">
                        <div className="ui5-txt-not-important w-100">Row</div>
                    </div>}

                <div className={selectorsContainerClasses}>
                    <FieldFormElementView
                        className   = "max-w-200 w-200 m-r-8"
                        field       = {fieldSelector}
                        model       = {settings.rowsAggregate}
                        options     = {{
                            attachment          : 'top center',
                            targetAttachment    : 'bottom center'
                        }}
                        onChange    = {onChangeField}
                    />

                    {isAggregateSelected &&
                    <>
                        <FieldFormElementView
                            className   = "max-w-200 w-100 m-r-8"
                            field       = {fieldFunctionSelector}
                            model       = {settings.rowsAggregate}
                            options     = {{
                                attachment          : 'top center',
                                targetAttachment    : 'bottom center'
                            }}
                            onChange    = {onChangeFunction}
                        />
                    </>}
                </div>
            </div>
        </div>
    )
}